import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import styles from "../../../assets/styles/componentStyles/header.module.scss";
import GlobalButton from "../../utility/globalButton/button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext, UserContextPayload } from "../../../context/userContext";
import agent from "../../../services/api";
import { Collapse, Grid, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, } from "@mui/material";
import globalStyles from "../../../assets/styles/global.module.scss"
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { ChatbotContext, ChatbotContextPayload } from "../../../context/chatbotContext";
import timezoneImg from "../../../assets/images/chatbot/timezone.png";
import { IntegrationContext, IntegrationContextPayload } from "../../../context/integrationContext";
import TimeZoneComponent from "../../utility/timeZoneComponent";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { CallAnalysisContext, CallAnalysisContextPayload } from "../../../context/callAnalysisContext";
import { ContactContext, ContactContextPayload } from "../../../context/contactContext";
import { useGenericStore } from "../../../store/genericStore";
import IconsColor from "../../utility/iconsColor";
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from "../../../context/whatsappCampaignContext";
import { metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from "../../../models/axiosModel";
import BreadCrumb from "../../global/breadCrumb";
import { WorkflowContext, WorkflowContextPayload } from "../../../context/workflowContext";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useKnowledgeBaseStore } from "../../../store/knowledgeBaseStore";
import { useIntentStore } from "../../../store/intentStore";
import WorkflowHeaderText from "../../dashboard/workflow/workflowHeaderText";
import WorkflowActionBlock from "../../dashboard/workflow/workflowActionBlock";
import OrganizationHeaderText from "../../dashboard/organization/organizationHeaderText";
import { useProductStore } from "../../../store/productStore";
import { hasCampaignManageAccess, hasContactManageAccess, hasCustomAPIPageManageAccess, hasProductManageAccess, hasVoiceAgentManagePermission } from "../../../utils/constants";
import { WhatsappTemplateContext, WhatsappTemplateContextPayload } from "../../../context/whatsappTemplateContext";
import GlobalTooltip from "../../utility/tooltip/globalTooltip";
import { isArchivedContactList } from "../../dashboard/contacts/contactConstant";

interface menuItem {
  menuName: string;
  menuKey: string;
  navigationLink: string;
  imgSrc: React.ReactElement;
  whiteImgSrc: React.ReactElement;
  coloredImgSrc: React.ReactElement;
  flagDisabled?: boolean
}
interface Props {
  flagShowLogo: boolean,
  menuItems?: menuItem[]
}

export default function Header(props: Props) {

  // const ITEM_HEIGHT = 15;
  let urlToNavigateTo = encodeURIComponent(window.location.href)
  const navigate = useNavigate();
  const { userDetail, setFlagLoading, flagLoading, setFlagOnboardingSkip, handleError, apiRoutesPermissionAssignment } = React.useContext(
    UserContext
  ) as UserContextPayload;
  const { campaignContactListData, setCampaignContactData, setFilteredCampaignContactData, campaignContactData, setFlagAddNewListDialog, setFlagCreateNewContactDialog, setFlagNewFieldDialog } = React.useContext(ContactContext) as ContactContextPayload;
  const globalStatusData = useGenericStore((state) => state.listOfChatbotStatus);
  const { setSelectedWhatsAppCampaign } = React.useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
  const { setFlagNewWorkflowPopup }  = React.useContext(WorkflowContext) as WorkflowContextPayload
  const { callRecordsData } = React.useContext(CallAnalysisContext) as CallAnalysisContextPayload
  const { showLegacyImportPopup, setShowLegacyImportPopup } = React.useContext(WhatsappTemplateContext) as WhatsappTemplateContextPayload;
  const setFlagCreateIntentPopup = useIntentStore((state) => state.setFlagCreateIntentPopup);
  const setFlagUploadKnowledgeBaseFilePopup = useKnowledgeBaseStore((state) => state.setFlagUploadKnowledgeBaseFilePopup);
  
  const setFlagCreateProductPopup = useProductStore((state) => state.setFlagCreateProductPopup);
  
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [searchParams, setSearchParams] = useSearchParams()
  const [showTimeZone, setShowTimeZone] = React.useState(false)


  const chatbot_id = searchParams.get('chatbot_id')
  const id = searchParams.get('id')
  const agentId = searchParams.get('voice_agent_id')
  const templateID = searchParams.get('template_id')
  const { chatBotDetails } = React.useContext(ChatbotContext) as ChatbotContextPayload
  const { integrationListNewStructure } = React.useContext(IntegrationContext) as IntegrationContextPayload
  const { setFlagAddFilter } = React.useContext(CallAnalysisContext) as CallAnalysisContextPayload

  const [pendingUpdate, setPendingUpdate] = React.useState<NodeJS.Timeout | null>(null);

  const getCurrentActiveMenuName = () => {
    if (window.location.pathname.toLowerCase() == "/chatbot") {
      return "AI Chatbot"
    } 
    else if (window.location.pathname.toLowerCase() == "/get-started") {
      return "Get Started"
    }
    // Tim Safransky's organization ID
    // userDetail?.user_organization_data?.organization_id != 2582
    else if (window.location.pathname.toLowerCase() == "/" && userDetail?.user_organization_data?.organization_id != 2545) {
      // return "AI Chatbot" 
      // return "WhatsApp Campaign" 
      return "Dashboard"
    }
    else if (window.location.pathname.toLowerCase() == "/" && userDetail?.user_organization_data?.organization_id == 2545) {
      return "Channels"
    }
    // else if (window.location.pathname.toLowerCase() == "/" && userDetail?.user_organization_data?.organization_id == 2582) {
    //   return "Dashboard"
    // }
    else if (window.location.pathname.toLowerCase() == "/supportticket") {
      return "Support Tickets"
    }
    else if (window.location.pathname.toLowerCase() == "/insights" || window.location.pathname.toLowerCase() == "/dashboard") {
      return "Dashboard"
    }
    else if (window.location.pathname.toLowerCase() == "/contacts") {
      const list_id = searchParams.get('contact_list_id');
      let headerText = "Contacts";
      if (list_id) {
        headerText = campaignContactListData && campaignContactListData?.find((list) => list.contact_list_id === Number(list_id))?.contact_list_name || "Contacts";
      } else {
        if (campaignContactListData && campaignContactListData.length > 0) headerText = "List";
      }
      return headerText
    }
    else if (window.location.pathname.toLowerCase() == "/createchatbot") {
      return "Create Chatbot"
    }
    else if (window.location.pathname.toLowerCase() == "/whatsappcampaign") {
      return "WhatsApp Campaign"
    }
    else if (window.location.pathname.toLowerCase() === "/whatsappcampaign/createnewcampaign") {
      return "Create New Campaign"
    }
    else if (window.location.pathname.toLowerCase() == "/whatsappcampaign/dashboard") {
      return "Dashboard"
    }
    else if (window.location.pathname.toLowerCase() === "/workflow") {
      return "Rule-Based Chatbot"
    } 
    else if(window.location.pathname.toLowerCase() === "/workflow/staticworkflowdetails") {
      return <WorkflowHeaderText />;
    }
    else if (window.location.pathname.toLowerCase() === "/customapi") {
      return "Custom API"
    }
    else if (window.location.pathname.toLowerCase() === "/customapi/createcustomapi") {
      return "Create Custom API"
    }
    else if (window.location.pathname.toLowerCase() === "/webhook") {
      return "Webhook"
    }
    else if (window.location.pathname.toLowerCase() === "/intent") {
      return "Intent"
    }
    else if (window.location.pathname.toLowerCase() === "/product") {
      return "Product"
    }
    else if (window.location.pathname.toLowerCase() === "/knowledge-base") {
      return "Knowledge Base"
    }
    else if (window.location.pathname.toLowerCase() === "/orderdetails") {
      return "Order Details"
    }
    else if (window.location.pathname.toLowerCase() === "/conversionleads") {
      return "Conversion Leads"
    }
    else if (window.location.pathname.toLowerCase() == "/settings-accountdetails" || window.location.pathname.toLowerCase() == "/settings-plansandbilling") {
      return "Settings"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/basicdetail" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot") {
      return "Basic Details"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration") {
      return "Integrations"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/createintegration") {
      return "Create Integration"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/whatsapp") {
      return "WhatsApp"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/facebook") {
      return "FB Messenger"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/instagram") {
      return "Instagram"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/website") {
      return "Website"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/slack") {
      return "Slack"
    }
    // else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/channels/zoho") {
    //   return "Zoho"
    // }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/trychatbot") {
      return "Try Chatbot"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/inbox" || window.location.pathname.toLowerCase() == "/inbox" || window.location.pathname.toLowerCase() === "/rulebasedinbox") {
      return "Inbox"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/persistentmenu") {
      return "Persistent Menu"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/subaichatbot") {
      return "Sub AI Chatbots"
    }
    else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/leadgeneration")) {
      return "Lead Generation"
    }
    else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/messageformat" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/messageformat/staticformat") {
      return "UI Components"
    }
    else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/products") {
      return "Products"
    }
    else if (window.location.pathname.toLowerCase() == "/channels") {
      return "Channels"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp") {
      return "Account Setup"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/phonenumbers") {
      return "Phone Numbers"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/phonenumbers/customrecipient") {
      return "Custom Recipients"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/templatemessages") {
      return "Template Messages"
    }
    else if(window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/flows" || window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/flowdetails"){
      return "WhatsApp Flows"
    }
    else if(window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/paymentconfiguration"){
      return "Payment Configuration"
    }
    else if(window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/paymentconfiguration"){
      return "Payment Configuration"
    }
    else if(window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/carouseltemplategroups"){
      return "Carousel Template Groups"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/legacy/templateinfo") {
      if (window.location.search.includes('template_id')) {
        return "Template Info"
      }
      return "New Template Message"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/templatelibrary") {
      return "Template Library"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate") {
      if (window.location.search.includes('template_id')) {
        return "Create New Template"
      }
      return "Modify Template"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook") {
      return "Account Setup"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook/pages") {
      return "Pages"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook/templateinfo" || window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook/templatemessages") {
      return "Template Messages"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/instagram") {
      return "Account Setup"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/slack") {
      return "Account Setup"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/slack/channels") {
      return "Slack Channels"
    }
    else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/zoho") {
      return "Account Setup"
    }
    else if (window.location.pathname.toLowerCase() === "/callanalysis") {
      return "Dashboard"
    }
    else if (window.location.pathname.toLowerCase() === "/callanalysis/callrecords") {
      return "Call Records"
    }
    else if (window.location.pathname.toLowerCase() === "/callanalysis/callrecords/newcallrecords") {
      return "New Call Records"
    }
    else if (window.location.pathname.toLowerCase() === "/organization" || window.location.pathname.toLowerCase() === "/organization/ticketsubstatus" || window.location.pathname.toLowerCase() === "/organization/teams") {
      // return "Workspace"
      return <OrganizationHeaderText />;
    } 
    else if(window.location.pathname.toLowerCase() === "/apikeys"){
      return "API Keys";
    }
    else if (window.location.pathname.toLowerCase() === "/billing-usage") {
      return "Billing & Usage"
    }
    else if (window.location.pathname.toLowerCase() === "/plans") {
      return "Plans"
    }
    else if (window.location.pathname.toLowerCase() === "/analytics") {
      return "Dashboard"
    }
    else if (window.location.pathname.toLowerCase() === "/voiceagent") {
      return "Voice Agents"
    }
    else if (window.location.pathname.toLowerCase() === "/voiceagent/createvoiceagent") {
      return agentId ? "Update Voice Agent" : "Create Voice Agent"
    }
    else if (window.location.pathname.toLowerCase() === "/voiceagent/createvoiceagent/deployments") {
      return "Voice Agent Deployments"
    }
    else if (window.location.pathname.toLowerCase() === "/voiceagent/createvoiceagent/customapi") {
      return "Custom API"
    }
    else {
      return "AI Chatbot"
    }
  }

  const getCurrentActiveMenuOnclickFun = () => {
    if (window.location.pathname.toLowerCase() == "/chatbot" || window.location.pathname.toLowerCase() == "/chatbot/" || window.location.pathname == "/") {
      return navigate("/chatbot")
    }
    else if (window.location.pathname.toLowerCase() == "/createchatbot") {
      return navigate("/createChatbot")
    }
    else if (window.location.pathname.toLowerCase() == "/inbox") {
      return navigate("/inbox")
    }
    else if (window.location.pathname.toLowerCase() == "/channels") {
      return navigate("/channels")
    }
    else if (window.location.pathname.toLowerCase() == "/settings-accountDetails" || window.location.pathname.toLowerCase() == "/settings-plansAndBilling") {
      return "Settings"
    }
    else {
      return navigate("/")
    }
  }



  React.useEffect(() => {
    // Cleanup the pending update when the component unmounts
    return () => {
      if (pendingUpdate !== null) {
        clearTimeout(pendingUpdate);
      }
    };
  }, [pendingUpdate]);

  const [headerListMenu, setHeaderListMenu] = React.useState<null | HTMLElement>(null);
  const [headerStaticListMenu, setHeaderStaticListMenu] = React.useState<null | HTMLElement>(null);
  const [openList, setOpenList] = React.useState(true);

  // Boolean(openSection1Anchor);
  const open = Boolean(headerListMenu);
  const openStaticMenu = Boolean(headerStaticListMenu)


  const handleClickHeaderListMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setHeaderListMenu(event.currentTarget);
  };

  const handleCloseHeaderListMenu = () => {
    setHeaderListMenu(null);
  };

  const handleClick = () => {
    setOpenList(!openList);
  };

  const handleClickStatictMenuList = (event: React.MouseEvent<HTMLButtonElement>) => {
    setHeaderStaticListMenu(event.currentTarget);
  };

  const handleCloseStaticMenuList = () => {
    setHeaderStaticListMenu(null);
  };

  const handleAddNewAgent = () => {
    navigate(`/voiceagent/createvoiceagent`)
  }

  const recordsMenuItems = [
    { label: 'View Dashboard', icon: <IconsColor iconName="callanalysisdashboard" width="16" height="16" fillColor="#000" />, action: (e: any) => navigate("/callanalysis") },
    { label: 'New Record', icon: <AddIcon sx={{ padding: "0", color: "#000", fontSize: "24px", marginLeft: "-4px" }} />, action: (e: any) => navigate("/callanalysis/callrecords/newcallrecords") },
  ];

  const dashboardMenuItems = [
    { label: 'View Records', icon: <IconsColor iconName="callAnalysis" width="16" height="16" fillColor="#000" />, action: (e: any) => navigate("/callanalysis/callrecords") },
  ]

  const contactMenuItem = [
    {
      label: 'Manage List',
      action: (e: any) => {
        navigate("/contacts");
        // setCampaignContactData([]); 
        setCampaignContactData(null);
        // setFilteredCampaignContactData([]);
        setFilteredCampaignContactData(null);
      }
    },
    ...(hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isArchivedContactList(campaignContactData?.[0], globalStatusData) ? [
      {
        label: 'Add New Field',
        action: (e: any) => {
          setFlagNewFieldDialog(true);
        }
      },
      {
        label: 'Add New Contact',
        action: (e: any) => {
          setFlagCreateNewContactDialog(true);
        }
      }
    ] : [])
  ]

  const listMenuItems = [
    {
      label: 'Add New List',
      action: (e: any) => {
        setFlagAddNewListDialog(true);
      }
    }
  ]

  const shouldShowContactPageActionBtns = () => {
    if(window.location.pathname.toLowerCase() == "/contacts" && campaignContactListData && campaignContactListData.length > 0){
      if(!searchParams.get('contact_list_id')){
        if(hasContactManageAccess(apiRoutesPermissionAssignment, userDetail)){
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  const shouldShowWhatsappLegacyTemplateMenuItem = () => {
    if(window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp/legacy/templateinfo" && !templateID){
      return true;
    }
    return false;
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <AppBar component="nav" className={styles.headerAppBar} >

        <Toolbar className={styles.headerToolBar}>
          <Grid container className={styles.spaceBetweenCenter}>

            <Grid item className={styles.headerWrapper}>

              <Grid container className={styles.logoContainer}>

                {/* current active menu name */}
                <Grid item className={styles.documentNameAreaContainer}>
                  <Grid container className={`${styles.currentActiveMenuContainer} ${chatbot_id || id ? styles.center : styles["space-between"]}`}>
                    <Grid item xs={12} className={styles.currentActiveMenuItem} >
                      {getCurrentActiveMenuName()}
                    </Grid>
                    {(chatbot_id || id) &&
                      <Grid item xs={12} className={styles.breadCrumbWrapper} >
                        <BreadCrumb />
                      </Grid>
                    }
                    {
                      (getCurrentActiveMenuName() == "Inbox" || getCurrentActiveMenuName() == "Support Tickets") &&
                      <Grid item className={styles.timeZoneItem}>
                        <Box
                          className={styles.timeZoneBox}
                          onClick={(event) => { setShowTimeZone(true); setAnchorEl(event.currentTarget) }}
                          aria-controls={showTimeZone ? 'account-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={showTimeZone ? 'true' : undefined}
                        >
                          <img src={timezoneImg} alt="timezone" className={styles.timeZoneImagStyle} />
                        </Box>
                        {showTimeZone && <TimeZoneComponent showTimeZone={showTimeZone} setShowTimeZone={setShowTimeZone} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />}
                      </Grid>
                    }
                    {(getCurrentActiveMenuName() == "WhatsApp Campaign" &&  hasCampaignManageAccess(apiRoutesPermissionAssignment, userDetail)) &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => { navigate('/whatsappcampaign/createnewcampaign'); setSelectedWhatsAppCampaign(null); }}
                        >
                          <AddIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    } 
                    {
                      getCurrentActiveMenuName() == "Rule-Based Chatbot" &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => { setFlagNewWorkflowPopup(true); }}
                        >
                          <AddIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    }
                    {
                      window.location.pathname.toLowerCase() == "/workflow/staticworkflowdetails" &&  
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <WorkflowActionBlock />
                      </Grid>
                    }
                    {
                      getCurrentActiveMenuName() == "Intent" &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => { setFlagCreateIntentPopup(true); }}
                        >
                          <AddIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    }
                    {
                      getCurrentActiveMenuName() == "Knowledge Base" &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => { setFlagUploadKnowledgeBaseFilePopup(true); }}
                        >
                          <FileUploadIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    }
                    {getCurrentActiveMenuName() == "Custom API" && hasCustomAPIPageManageAccess(apiRoutesPermissionAssignment, userDetail) &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => { navigate(`/customAPI/createCustomAPI`) }}
                        >
                          <AddIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    }

                    {(getCurrentActiveMenuName() == "Product"  && hasProductManageAccess(apiRoutesPermissionAssignment, userDetail))&&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => setFlagCreateProductPopup(true)}
                        >
                          <AddIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    }

                    {getCurrentActiveMenuName() == "Voice Agents" && hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <IconButton
                          className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.addChatbotIcon}`}
                          onClick={() => handleAddNewAgent()}
                        >
                          <AddIcon className={globalStyles.iconStyle} />
                        </IconButton>
                      </Grid>
                    }

                    {(callRecordsData && callRecordsData.call_center && callRecordsData.call_center.length > 0) && (window.location.pathname.toLowerCase() === "/callanalysis" || getCurrentActiveMenuName() == "Call Records" || getCurrentActiveMenuName() == "New Call Records") &&
                      <Grid item className={styles.absoluteAlignment}>
                        <Grid container className={`${globalStyles.globalHeadMainItemRightContainer}`} gap="10px" justifyContent={{ lg: "end" }}>
                          {
                            (getCurrentActiveMenuName() == "Dashboard" || getCurrentActiveMenuName() == "Call Records") &&
                            <Grid item>
                              <IconButton
                                className={`${globalStyles.cmpGlobalMobileAddIcon} ${styles.addFilterIcon}`}
                                onClick={() => { setFlagAddFilter(true) }}
                              >
                                <FilterAltOutlinedIcon className={globalStyles.iconStyle} />
                              </IconButton>
                            </Grid>
                          }
                          <Grid item>
                            <Button
                              id="basic-button"
                              className={openStaticMenu ? styles.exploreMenuButtonOpen : styles.exploreMenuButton}
                              aria-controls={openStaticMenu ? 'basic-menu' : undefined}
                              aria-haspopup="true"
                              aria-expanded={openStaticMenu ? 'true' : undefined}
                              disableRipple
                              onClick={(event) => { event.stopPropagation(); handleClickStatictMenuList(event) }}
                            >
                              <MoreVertIcon />
                            </Button>
                            <Menu
                              id="basic-menu"
                              anchorEl={headerStaticListMenu}
                              open={openStaticMenu}
                              className={globalStyles.globalMenuStyle}
                              onClose={handleCloseStaticMenuList}
                              MenuListProps={{
                                'aria-labelledby': 'basic-button',
                              }}
                              sx={{
                                "& .MuiMenuItem-root": { margin: "0 !important", minHeight: "0 !important" }
                              }}
                            >
                              {window.location.pathname !== "/callanalysis/callrecords" ?
                                dashboardMenuItems.map((item: any, index: any) => (
                                  <MenuItem
                                    key={index}
                                    onClick={(e) => { e.stopPropagation(); item.action(); handleCloseStaticMenuList(); }}
                                    className={styles.menuItemPadding}

                                  >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <span style={{ fontSize: "14px", fontWeight: "500" }}>{item.label}</span>
                                  </MenuItem>
                                ))
                                :
                                recordsMenuItems.map((item: any, index: any) => (
                                  <MenuItem
                                    key={index}
                                    onClick={(e) => { e.stopPropagation(); item.action(); handleCloseStaticMenuList(); }}
                                    className={styles.menuItemPadding}

                                  >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <span style={{ fontSize: "14px", fontWeight: "500" }}>{item.label}</span>
                                  </MenuItem>
                                ))
                              }
                            </Menu>
                          </Grid>
                        </Grid >
                      </Grid >
                    }
                    { shouldShowContactPageActionBtns() &&
                      <Grid item className={styles.absoluteAlignment} >
                        <Grid container className={`${globalStyles.globalHeadMainItemRightContainer}`} gap="10px" justifyContent={{ lg: "end" }}>

                          <Grid item>
                            <Button
                              id="basic-button"
                              className={openStaticMenu ? styles.exploreMenuButtonOpen : styles.exploreMenuButton}
                              aria-controls={openStaticMenu ? 'basic-menu' : undefined}
                              aria-haspopup="true"
                              aria-expanded={openStaticMenu ? 'true' : undefined}
                              disableRipple
                              style={{ marginBottom: "5px" }}
                              onClick={(event) => { event.stopPropagation(); handleClickStatictMenuList(event) }}
                            >
                              <MoreVertIcon />
                            </Button>
                            <Menu
                              id="basic-menu"
                              anchorEl={headerStaticListMenu}
                              open={openStaticMenu}
                              className={globalStyles.globalMenuStyle}
                              onClose={handleCloseStaticMenuList}
                              MenuListProps={{
                                'aria-labelledby': 'basic-button',
                              }}
                              sx={{
                                "& .MuiMenuItem-root": { margin: "0 !important", minHeight: "0 !important" }
                              }}
                            >
                              {!searchParams.get('contact_list_id') ?
                                listMenuItems.map((item: any, ind: number) => (
                                  <MenuItem
                                    key={ind}
                                    onClick={(e) => { e.stopPropagation(); item.action(); handleCloseStaticMenuList(); }}
                                    className={styles.menuItemPaddingTen}
                                  >
                                    <span className={styles.menuItemStyling}  >{item.label}</span>
                                  </MenuItem>
                                ))
                                :
                                contactMenuItem.map((item: any, ind: number) => {
                                  if (item.label === "Add New Contact") {
                                    if (campaignContactData && campaignContactData.length === 0) {
                                      return <React.Fragment key={ind}></React.Fragment>;
                                    }
                                  }
                                  return <MenuItem
                                    key={ind}
                                    onClick={(e) => { e.stopPropagation(); item.action(); handleCloseStaticMenuList(); }}
                                    className={styles.menuItemPaddingTen}
                                  >
                                    <span className={styles.menuItemStyling} >{item.label}</span>
                                  </MenuItem>
                                })
                              }
                            </Menu>
                          </Grid>
                        </Grid>
                      </Grid>
                    }
                    
                    {shouldShowWhatsappLegacyTemplateMenuItem() &&
                      <Grid item className={styles.cmpGlobalMobileAddIconDarkItem} >
                        <GlobalTooltip
                            title="Import Template"
                            placement="bottom"
                        >
                          <IconButton
                              className={`${globalStyles.cmpGlobalMobileAddIconDark} ${styles.importTemplateIcon}`}
                              onClick={() => setShowLegacyImportPopup(true)}
                              style={{ zIndex: 1 }}
                          >
                              <FileDownloadIcon className={globalStyles.iconStyle} />
                          </IconButton>
                        </GlobalTooltip>
                      </Grid>
                    }
                  </Grid>
                </Grid >
              </Grid >
            </Grid >

            <Grid item className={styles.creditWrapper} >
              <Grid container>
                {/* logout/signup buttons for above 650px */}
                <Grid item className={styles.headerButtonWrapperSM}>
                  {/* logout button */}
                  <Grid item className={styles.exploreMenuGrid}>
                    <Button
                      id="basic-button"
                      className={open ? styles.exploreMenuButtonOpen : styles.exploreMenuButton}
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClickHeaderListMenu}
                    >
                      <Grid className={styles.moreVerticalIcon}><MoreVertIcon /></Grid>
                    </Button>

                    <Menu
                      id="basic-menu"
                      anchorEl={headerListMenu}
                      open={open}
                      className={styles.moreVerticalIconMenu}
                      onClose={handleCloseHeaderListMenu}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >

                      <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        className={styles.menuItemList}
                      >

                        <ListItemButton className={`${styles.listItemButtonComponent} ${styles.emailListComponent}`}>
                          <ListItemIcon>
                            <AccountCircleOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary={userDetail.flag_user_anonymous ? "Guest User" : userDetail.user_email} />
                        </ListItemButton>

                        <ListItemButton onClick={handleClick} className={`${styles.listItemButtonComponent} ${styles.exploreMenuButtonWidth}`}>
                          <ListItemIcon>
                          </ListItemIcon>
                          <ListItemText primary="Explore" />
                          {openList ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItemButton>

                        <Collapse in={openList} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding className={styles.listItemButtonComponent}>
                            {props.menuItems?.map((menuItem, index) => {
                              return (
                                <ListItemButton className={styles.subListMenuItem} key={index} onClick={() => navigate(menuItem.navigationLink)}>
                                  <ListItemIcon>
                                    {menuItem.imgSrc}
                                  </ListItemIcon>
                                  <ListItemText primary={menuItem.menuName} />
                                </ListItemButton>
                              )
                            })}

                          </List>
                        </Collapse>

                        {userDetail.flag_user_anonymous === false && (
                          <ListItemButton className={styles.listItemButtonComponent}
                            onClick={async () => {
                              setFlagLoading({ ...flagLoading, flagRoundLoader: true });;
                              const response = await agent.LogoutAPI.post();
                              if (response.status) {
                                setFlagOnboardingSkip(null)
                                window.location.href = "/login";
                              } else {
                                handleError(response);
                              }
                              setFlagLoading({ ...flagLoading, flagRoundLoader: false });;
                            }}
                          >
                            <ListItemIcon>
                              <PowerSettingsNewIcon />
                            </ListItemIcon>
                            <ListItemText primary="Logout" />
                          </ListItemButton>
                        )}

                      </List>
                    </Menu>
                  </Grid>
                </Grid>


                {/* logout/signup buttons for below 650px and above 599 */}
                {/* <Grid item className={styles.headerButtonWrapperXS}>
                  {userDetail.flag_user_anonymous && (
                    <GlobalButton
                      className={"primaryButtonStyleIcon"}
                      buttonText={<AppRegistrationIcon />}
                      onClick={() => {
                        navigate("/login?redirect=" + urlToNavigateTo);
                      }}
                    />
                  )}

                  <Grid item className={styles.expandMoreGridMobile} mx={1}>
                    <Button
                      id="basic-button"
                      className={open ? styles.exploreMenuButtonOpen : styles.exploreMenuButton}
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClickHeaderListMenu}
                    >
                      <Grid className={styles.moreVerticalIcon}><MoreVertIcon /></Grid>
                    </Button>

                    <Menu
                      id="basic-menu"
                      anchorEl={headerListMenu}
                      open={open}
                      className={styles.moreVerticalIconMenu}
                      onClose={handleCloseHeaderListMenu}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >

                      <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        className={styles.menuItemList}
                      >

                        <ListItemButton className={styles.listItemButtonComponent}>
                          <ListItemIcon>
                            <AccountCircleOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary={userDetail.flag_user_anonymous ? "Guest User" : userDetail.user_email} />
                        </ListItemButton>

                        <ListItemButton onClick={handleClick} className={`${styles.listItemButtonComponent} ${styles.exploreMenuButtonWidth}`}>
                          <ListItemIcon>
                          </ListItemIcon>
                          <ListItemText primary="Explore" />
                          {openList ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItemButton>

                        <Collapse in={openList} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding className={styles.listItemButtonComponent}>
                            {props.menuItems?.map((menuItem, index) => {
                              return (
                                <ListItemButton className={styles.subListMenuItem} key={index} onClick={() => navigate(menuItem.navigationLink)}>
                                  <ListItemIcon>
                                    {menuItem.imgSrc}
                                  </ListItemIcon>
                                  <ListItemText primary={menuItem.menuName} />
                                </ListItemButton>
                              )
                            })}

                          </List>
                        </Collapse>

                        {userDetail.flag_user_anonymous === false && (
                          <ListItemButton className={styles.listItemButtonComponent}
                            onClick={async () => {
                              setFlagLoading({ ...flagLoading, flagRoundLoader: true });;
                              const response = await agent.LogoutAPI.post();
                              if (response.status) {
                                setFlagOnboardingSkip(null)
                                resetOrganizationContext()
                                setUserDetail({ ...userDetail, flagUser: false });
                                navigate("/login", { replace: true });
                              } else {
                                handleError(response);
                              }
                              setFlagLoading({ ...flagLoading, flagRoundLoader: false });;
                            }}
                          >
                            <ListItemIcon>
                              <PowerSettingsNewIcon />
                            </ListItemIcon>
                            <ListItemText primary="Logout" />
                          </ListItemButton>
                        )}

                      </List>
                    </Menu>
                  </Grid>

                </Grid> */}

              </Grid>
            </Grid>




          </Grid >


        </Toolbar >
      </AppBar >
    </Box >
  );
}
